import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        alignItems: "center",
        height: "100%",

        backgroundColor: "transparent",
    },
    boxPrancheta: {
        height: "70vh",
        width: "90vw",
        backgroundColor: "white",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        position: "relative",
    },
    //    setDialogParam :{
    //
    //    }
    diagPrancheta: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "90vw",
        height: "70vh",
        "justify-content": "space-around",
    },
    diagPranchetaCanvas: {
        width: "600px",
        //        'border': '2px solid black',
    },
    diagPranchetaDados: {
        display: "flex",
        flexDirection: "column",
        width: "600px",
    },
    diagPranchetaBotoes: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "black",
            color: "white",
        },
        /*        'display': 'flex',*/
        width: "100%",
        height: "300px",
        marginTop: "12px",
        /*        'flexFlow': '1',
            'align-content': 'center',
            'alignItems': 'center',*/
        /*        'border': '5px solid blue',*/
        backgroundColor: "white",
    },

    box_analise: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    box_analise_cabecalho: {
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#2471A3",
        height: "70px",
    },
    box_analise_conteudo: {
        display: "flex",
        flexDirection: "column",
        height: "100px",
        alignContent: "center",
        alignItems: "flex-start",
        justifyContent: "center",
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    button_download: {
        margin: "10px",
        display: "flex",
        alignItems: "center",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    imagem: {
        border: "2px solid black",
        flexDirection: "column",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
